import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { useCreatorClusters } from 'contexts/CreatorClustersContext'
import { useTranslate } from 'lib/tolgee'
import { getClusterTitleForTooltip } from 'utils/getClusterTitleByType'

import { DEFAULT_CLUSTER_TOOLTIP_KEY, DEFAULT_CLUSTER_TYPE } from './creator-clusters-wrapper.consts'
import type { ICreatorClustersWrapperModel, ILocationState } from './creator-clusters-wrapper.types'

export const useCreatorClustersWrapperModel = (): ICreatorClustersWrapperModel => {
  const { clusterId, handleClusterClick } = useCreatorClusters()
  const history = useHistory()
  const location = useLocation<ILocationState>()
  const t = useTranslate()

  const clusterIdFromLocationState = location?.state?.clusterId ?? null

  useEffect(() => {
    if (clusterIdFromLocationState) {
      handleClusterClick(
        clusterIdFromLocationState,
        DEFAULT_CLUSTER_TYPE,
        getClusterTitleForTooltip(t, DEFAULT_CLUSTER_TOOLTIP_KEY)
      )

      const newState = { ...location.state }
      delete newState.clusterId
      history.replace({ ...location, state: newState })
    }
  }, [clusterIdFromLocationState, handleClusterClick, t, history, location])

  const isLoading = !!clusterIdFromLocationState && clusterIdFromLocationState !== clusterId
  const showClusterPage = !!clusterId

  return {
    clusterId,
    isLoading,
    showClusterPage,
  }
}
